import { eventTracker } from 'app/modules/Segment';
import {
  FeatureEnum,
  GroupIdEnum,
  OwnerEnum,
  TContext,
  TProperties,
} from 'app/modules/Segment/types';

const EVENTS = {
  JUS_MAIL_CARD_VALIDATION_FAILED: 'jus_mail_card_validation_failed',
  JUS_MAIL_SAVE_CARD_CALLBACK_FAILED: 'jus_mail_save_card_callback_failed',
  JUS_MAIL_CARD_PROCESSING_FAILED: 'jus_mail_card_processing_failed',
  JUS_MAIL_LOAD_CARDS_FAILED: 'jus_mail_load_cards_failed',
  JUS_MAIL_SELECTED_CARD_PAYMENT_FAILED: 'jus_mail_selected_card_payment_failed',
} as const;

const JUSMAIL_LIBRARY_NAME = 'jusmail-library';
const JUSMAIL_FEATURE = FeatureEnum.JUSMAIL;

function buildBaseProperties(
  eventText: string,
  relevantUserActivity: boolean,
  eventMeaning: string,
  overrides: Partial<TProperties> = {},
): TProperties {
  return {
    owner: OwnerEnum.INOVACAO,
    feature: JUSMAIL_FEATURE,
    event_meaning: eventMeaning,
    relevant_user_activity: relevantUserActivity,
    event_text: eventText,
    ...overrides,
  } as TProperties;
}

function buildContext(componentName: string): TContext {
  return {
    groupId: GroupIdEnum.JUSMAIL_GROUP,
    library: {
      name: JUSMAIL_LIBRARY_NAME,
      componente: componentName,
    },
  };
}

export function trackJusMailCardValidationFailed(props: {
  errorType: string;
  errorMessage: string;
  provider: string;
}): void {
  eventTracker.track({
    event: EVENTS.JUS_MAIL_CARD_VALIDATION_FAILED,
    properties: buildBaseProperties(
      'JusMail Card Validation Failed',
      false,
      'Disparado quando a validação dos dados do cartão falha antes do envio ao provedor de pagamento. Propriedades: `error_type`, `error_message`, `provider`.',
      {
        error_type: props.errorType,
        error_message: props.errorMessage,
        provider: props.provider,
      },
    ),
    context: buildContext('new-card-form-component'),
  });
}

export function trackJusMailSaveCardCallbackFailed(props: {
  errorType: string;
  errorMessage: string;
  provider: string;
}): void {
  eventTracker.track({
    event: EVENTS.JUS_MAIL_SAVE_CARD_CALLBACK_FAILED,
    properties: buildBaseProperties(
      'JusMail Save Card Callback Failed',
      false,
      'Disparado quando a busca dos cartões salvos falha após o salvamento bem-sucedido do cartão. Propriedades: `error_type`, `error_message`, `provider`.',
      {
        error_type: props.errorType,
        error_message: props.errorMessage,
        provider: props.provider,
      },
    ),
    context: buildContext('new-card-form-component'),
  });
}

export function trackJusMailCardProcessingFailed(props: {
  errorType: string;
  errorMessage: string;
  provider: string;
}): void {
  eventTracker.track({
    event: EVENTS.JUS_MAIL_CARD_PROCESSING_FAILED,
    properties: buildBaseProperties(
      'JusMail Card Processing Failed',
      false,
      'Disparado quando o processamento/tokenização do cartão falha no provedor de pagamento. Propriedades: `error_type`, `error_message`, `provider`.',
      {
        error_type: props.errorType,
        error_message: props.errorMessage,
        provider: props.provider,
      },
    ),
    context: buildContext('new-card-form-component'),
  });
}

export function trackJusMailLoadCardsFailed(props: {
  errorType: string;
  errorMessage: string;
}): void {
  eventTracker.track({
    event: EVENTS.JUS_MAIL_LOAD_CARDS_FAILED,
    properties: buildBaseProperties(
      'JusMail Load Cards Failed',
      false,
      'Disparado quando a listagem dos cartões salvos do usuário falha na API. Propriedades: `error_type`, `error_message`.',
      {
        error_type: props.errorType,
        error_message: props.errorMessage,
      },
    ),
    context: buildContext('select-card-form-component'),
  });
}

export function trackJusMailSelectedCardPaymentFailed(props: {
  errorType: string;
  errorMessage: string;
  cardId: string;
}): void {
  eventTracker.track({
    event: EVENTS.JUS_MAIL_SELECTED_CARD_PAYMENT_FAILED,
    properties: buildBaseProperties(
      'JusMail Selected Card Payment Failed',
      false,
      'Disparado quando o processamento do pagamento com um cartão previamente salvo falha. Propriedades: `error_type`, `error_message`, `card_id`.',
      {
        error_type: props.errorType,
        error_message: props.errorMessage,
        card_id: props.cardId,
      },
    ),
    context: buildContext('select-card-form-component'),
  });
}
